<template>
  <!-- 企業検診機器出荷 -->
  <div id="KenshinShippingList">
    <div id="container">
      <kenshinNavi v-bind:pageid='"KenshinShippingList"'></kenshinNavi>
      <div class="kenshinLabelTitle lable">企業検診 機器出荷</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" id="receiptNumber" v-model="searchConditions.receiptNumber"/></td>
            <th>デモ</th>
            <td><select id="demo" v-model="searchConditions.demo"><option></option><option value="false">含まない</option><option value="true">デモのみ</option></select></td>
            <th>機種</th>
            <td><select id="model" v-model="searchConditions.model"><option v-for="device in kenshinDeviceList" :value="device.value" :key="device.value">{{ device.label1 }}</option></select></td>
            <th>企業名</th>
            <td><input type="text" id="corporation" v-model="searchConditions.companyName"/></td>
          </tr>
          <tr>
            <th>出荷予定日</th>
            <td colspan="3"><input type="date" id="shippingDateStart" v-model="searchConditions.shippingDateStart"/> ～ <input type="date" id="shippingDateEnd" v-model="searchConditions.shippingDateEnd"/></td>
            <th>ステータス</th>
            <td><select v-model="searchConditions.status"><option v-for="status in statusList" :key="status.code" :value="status.code">{{status.name}}</option></select></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="hasResult">
        <div class="operation-area">
            <b-button class="operationButton is-primary" icon-left="microsoft-excel" @click="goInvoiceSheetView" :disabled="!checkedRows.length">送り状シート作成</b-button>
        </div>
        <b-table
            id="hstRequestAcceptTable"
            :data="data"
            :paginated="true"
            per-page="100"
            pagination-position="both"
            checkable
            :checked-rows.sync="checkedRows"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            @sort="sortPressed"
            :default-sort="sortField"
            :default-sort-direction="sortOrder"
            >
            <template slot-scope="props">
              <b-table-column field="receiptNumber" label="受付番号" width="100" sortable centered>
                <router-link :to="{name:'KenshinShippingListDetail', query:{receiptNumber:encodeURIComponent(props.row.receiptNumber)}, params:{searchConditions:searchConditions,sortField:sortField,sortOrder:sortOrder}}"><a>{{props.row.receiptNumber}}</a></router-link>
              </b-table-column>
              <b-table-column field="shippingDate" label="出荷予定日" width="80" sortable>
                {{props.row.shippingDate}}
              </b-table-column>
              <b-table-column field="model" label="機種" width="250" sortable >
                {{getChoiceName(props.row.model,kenshinDeviceList)}}<span v-if="props.row.demo" class="demo"/>
              </b-table-column>
              <b-table-column field="units" label="台数" width="50" sortable centered>
                {{props.row.units}}
              </b-table-column>
              <b-table-column field="companyName" label="企業名" width="300" sortable >
                {{props.row.companyName}}　{{props.row.office}}
              </b-table-column>
              <b-table-column field="address" label="配送先" sortable >
                {{props.row.address}}
              </b-table-column>
              <b-table-column field="status" label="ステータス" width="10" sortable centered>
                <span :class="getShippingTagClass(props.row.status)">
                  {{getStatusName(props.row.status)}}
                </span>
              </b-table-column>
            </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/kenshin/KenshinNaviBar";
import {choicesType} from "@/components/mock/base/const.js";

export default {
  name: "KenshinShippingList",
  methods: {
    doSearch: function(){
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getKenshinDeviceShipmentListPOST;
      var successCallBack = this.getKenshinDeviceShipmentListPOSTSuccess;
      var errorCallBack = this.getKenshinDeviceShipmentListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinDeviceShipmentListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.shippingDateStart = obj.shippingDateStart ? obj.shippingDateStart.replace(/-/g, "/") : ""
      obj.shippingDateEnd = obj.shippingDateEnd ? obj.shippingDateEnd.replace(/-/g, "/") : ""
      obj.status = obj.status && obj.status.length!=0 ? JSON.parse(obj.status) : []
      return client.apis.internalKenshin.getKenshinDeviceShipmentListPOST({
        body:obj
      });
    },
    getKenshinDeviceShipmentListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data.length > 0){
        this.hasResult = true;
      }
    },
    getKenshinDeviceShipmentListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getChoiceName: function(val,list) {
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    },
    getStatusName: function(code) {
      var target = this.statusList.find(val => val.code && val.code.includes(code))
      if(target){
        return target.name
      }
      return ""
    },
    goInvoiceSheetView: function() {
      var receiptNumber = this.checkedRows.map(item => item.receiptNumber)
      this.$router.push({
        name: "KenshinInvoiceSheetView",
        params: {receiptNumber:receiptNumber,searchConditions:this.searchConditions}
      });
    },
    sortPressed(field, order, event) {
      this.sortField = field
      this.sortOrder = order+""
    }
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var sField = this.$route.params["field"];
    var sOrder = this.$route.params["order"];
    var sortField = sField ? sField : ""
    var sortOrder = sOrder ? sOrder : ""
    var kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    kenshinDeviceList.unshift({})
    var statusList = this.getShippingStatusList()
    statusList = statusList.filter(val => val.name != "キャンセル")
    statusList.unshift({})
    return {
      kenshinDeviceList,
      searchConditions:{
        receiptNumber:"",
        demo:"",
        model:"",
        companyName:"",
        shippingDateStart:"",
        shippingDateEnd:"",
        status:""
      },
      statusList,
      takeOverSearchParams,
      data : [],
      hasResult:false,
      checkedRows:[],
      sortField,
      sortOrder
    };
  },
  async mounted() {
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {},
  components: {
    kenshinNavi: naviBar
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width :100px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinShippingList.vue